import * as React from 'react';
import * as SimpleMde from 'react-simplemde-editor';

import assign = require('object-assign');
import translate from '../../../../locale/translate';

import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';

interface IProps {
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export default class Editor extends React.Component<IProps, void> {
    static propTypes = {
        settings: React.PropTypes.object.isRequired,
        handleChange: React.PropTypes.func.isRequired
    };

    handleChange(markdown: string) {
        this.props.handleChange('text', markdown);
    }

    handleSelect(evt: React.ChangeEvent<HTMLSelectElement>) {
        this.props.handleChange(evt.target.name, evt.target.value);
    }

    render() {
        const { handleChange, settings } = this.props;

        return (
            <div className="form-group">
                <SimpleMde
                    onChange={this.handleChange.bind(this)}
                    value={settings.text}
                    options={{
                        spellChecker: false,
                        toolbar: ['bold', 'italic', 'heading', '|', 'quote', 'unordered-list', 'ordered-list', '|', 'guide'],
                        status: false,
                    }}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/basic/text/Editor.tsx